import { isGuestRoute } from "../constants";
import {
  handleReferralFromRoute,
  flushReferralQueueAfterLogin,
} from "@/utils/referralsTracker";

export function applyGlobalGuards(router, { store, isProtectedRoute }) {
  router.beforeEach(async (to, from, next) => {
    try {
      await handleReferralFromRoute({ store, route: to, onlyQueue: true });
    } catch (e) {
      if (process.env.NODE_ENV !== "production") {
        console.warn("[referral] beforeEach error:", e);
      }
    }

    const isResetPassPage =
      to.path.startsWith("/auth/pass") || to.path.startsWith("/auth/reset");

    if (!isResetPassPage && !store.state.authChecked) {
      try {
        await store.dispatch("tryRestoreSession");
      } catch (e) {
        // ignora: sessão ausente/expirada
      }
    }

    const isLogged = Boolean(store.state.user?.id);

    if (isLogged && isGuestRoute(to) && !to.meta?.publicMakerLinkSubdomain) {
      return next("/dashboard");
    }

    const protectedRoute = isProtectedRoute(to);

    if (protectedRoute && !isLogged) {
      return next("/login");
    }

    return next();
  });

  router.beforeResolve(async (to, from, next) => {
    try {
      const isLogged = Boolean(store?.state?.user?.id);

      if (isLogged) {
        await flushReferralQueueAfterLogin();
      }
    } catch (e) {
      if (process.env.NODE_ENV !== "production") {
        console.warn("[referral] beforeResolve error:", e);
      }
    }

    next();
  });
}
